/* eslint-disable */
import Backbone from 'backbone';

const mapField = function (field, fromModel, fieldName) {
    this.set(fieldName || field, fromModel.get(field));
    fromModel.on(`change:${field}`, (model, value) => {
        this.set(fieldName || field, value);
    });
};

Backbone.Model.prototype.mapState = function (fields, fromModel) {
    const self = this;
    switch (typeof fields) {
        case 'string':
            mapField.call(this, fields, fromModel);
            break;
        case 'object':
            _.each(fields, (field, key) => {
                mapField.call(self, field, fromModel, _.isArray(fields) ? false : key);
            });
            break;
        default:
    }
};

export default Backbone;
